export default {
	person: "Pessoa",
	journeyStage: "Jornada",
	since: "Desde",
	createAssignment: "Atribuir Jornada",
	assignNewPosition: "Atribuir Jornada",
	confirmDeleteMessage: "Tem certeza que deseja excluir a atribuição \"{name}\"? Esta ação não pode ser desfeita.",
	journeyProgressionInfo: "Apenas jornadas superiores ao nível atual ({currentLevel}) podem ser selecionadas.",
	createSuccess: "Atribuição criada com sucesso!",
	createError: "Erro ao criar atribuição",
	deleteSuccess: "Atribuição excluída com sucesso!",
	deleteError: "Erro ao excluir atribuição",
};
